import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import { classesAPI } from 'api/classesAPI';
import { coachingAPI } from 'api/coachingAPI';
import DeleteIcon from 'assets/images/delete.png';
import axios from 'axios';
import useGetCoachingData from 'hooks/useGetCoachingData';
import {
  cloneDeep,
  isEmpty,
} from 'lodash';
import {
  useLocation,
  useNavigate,
} from 'react-router-dom';
import {
  useRecoilState,
  useSetRecoilState,
} from 'recoil';
import {
  activeSubmit,
  fireSubmit,
} from 'state';
import styled from 'styled-components';
import {Icon, Overlay} from 'view/components';

import plus from '../../../../../assets/images/plus_s.png';
import {commonAPI} from "../../../../../api/commonAPI";
import PlusIcon from "../../../../../assets/images/icon/PlusIcon";
import {fadeIn} from "../../../../../styled/StyledComponent";
import QuestionMark from "../../../../../assets/images/icon/QuestionMark";
import QueText from "../../../../components/common/QueTest";

interface StyledComponentProps {
    width?: string;
    display?: string;
    justifyContent?: string;
}
interface LearingMaterialProps {
    file?: any;
}

const Showcase: React.FC<LearingMaterialProps> = () => {
    const {
        state: { createId },
    } = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { data: coachingData, stepData } = useGetCoachingData(
        createId,
        "getClassLearningMaterialById",
        loading
    );
    const setSubmit = useSetRecoilState(activeSubmit);
    const [submitFire, setSubmitFire] = useRecoilState(fireSubmit);
    const [question, setQuestion] = useState<string | undefined>();
    const [answer, setAnswer] = useState<string | undefined>();
    const [jwPlayerId, setJwPlayerId] = useState("")
    const [homeworkCompletionTime, setHomeworkCompletionTime] = useState<string | undefined>();
    const [homeworkFileTitle, setHomeworkFileTitle] = useState<string | undefined>();
    const [syllabusTitle, setSyllabusTitle] = useState("");
    const [sampleVideoFile, setSampleVideoFile] = useState(null)
    const [practiceFiles, setPracticeFiles] = useState([{ fileName: "", file: null }]);
    const syllabusFileInput = useRef(null);
    const homeworkFileInput = useRef(null);
    const [uploadLoading, setUploadLoading] = useState(false);
    const getFormData = () => {
        const formData = new FormData();
        // file        
        if(sampleVideoFile !== null){
            const syllabusBlob = new Blob([sampleVideoFile], {
                type: sampleVideoFile?.type,
            });
            formData.append("sampleVideoFile", syllabusBlob, sampleVideoFile?.name);
        };        

        // string
        question?.trim() && formData.append("question", question);
        answer?.trim() && formData.append("answer", answer);        
        return formData;
    };

    const handleUploadJWP = async (e) => {
        const file = e.target.files[0];
        console.log("file", file);

        if (!file) {
            return;
        }
        try {
            setUploadLoading(true)
            const result = await commonAPI.postVideoMetadata({
                data: {
                    metadata: {
                        title: file?.name,
                    },
                    upload: {
                        mimeType: file?.type,
                    },
                    fileName: file?.name,
                    preview: true,
                },
            });
            if (result) {
                const uploadLink = result.data.upload_link;
                if (result.data.jwPlayerId) {
                    setJwPlayerId(result.data.jwPlayerId)
                };
                const fileReader = new FileReader();
                fileReader.readAsArrayBuffer(file);
                fileReader.onload = async () => {
                    const arrayBuffer = fileReader.result as ArrayBuffer;
                    const uint8Array = new Uint8Array(arrayBuffer);
                    const buffer = uint8Array.slice();
                    axios({
                        method: "PUT",
                        url: uploadLink,
                        headers: {
                            "Content-Type": file?.type,
                        },
                        data: new Blob([buffer]),

                        // onUploadProgress: (progressEvent) => {
                        //     const percentage =
                        //         (progressEvent.loaded / (progressEvent.total || 1)) * 100;
                        //     const percentCompleted = Math.round(percentage);
                        //     setPercentage(percentCompleted);
                        // },
                    }).then((res) => {
                        console.log("video", res);
                        setSyllabusTitle(file?.name);
                        setUploadLoading(false);
                    });
                };
            }
        } catch (error) {
            console.log("error", error);
        }finally {

            e.target.value = ""
        }
    };

    const stringData = () => {
        const formData = new FormData();
        question?.trim() && formData.append("question", question);
        answer?.trim() && formData.append("answer", answer);
        return formData;
    };

    const putShowcaseData = async () => {
        await coachingAPI.putCoachingShowcase(createId,{
            data:{
                answer:answer,
                fileName:syllabusTitle,
                jwPlayerId:jwPlayerId,
                question:question,
                title:syllabusTitle
            }
        })
    }

    const removePractiveFile = async (index) => {
        await classesAPI
            .deleteClassLearningMaterial(createId, {
                data: {
                    deleteHomeworkFile: false,
                    deleteSyllabusFile: false,
                    practiceFileOrder: [index],
                },
            })
            .then((res) => {
                setLoading((v) => !v);
            });
    };

    const deleteSyllabus = async () => {
        await classesAPI
            .deleteClassLearningMaterial(createId, {
                data: {
                    deleteHomeworkFile: false,
                    deleteSyllabusFile: true,
                },
            })
            .then((res) => {
                setLoading((v) => !v);
            });
    };

    const deleteHomework = async () => {
        await classesAPI
            .deleteClassLearningMaterial(createId, {
                data: {
                    deleteHomeworkFile: true,
                    deleteSyllabusFile: false,
                },
            })
            .then((res) => {
                setLoading((v) => !v);
            });
    };

    const putLearningMaterial = async (practiceFiles, isString = false) => {
        await classesAPI
            .putClassLearningMaterial(createId, {
                data:getFormData()
            })
            .then((res) => {
                console.log("suc", res);
            })
            .catch((e) => {
                console.log("failed", e);
            });
    };

    const handlePracticeFileList = (isAdd: boolean, index?: number) => {
        const copyData = cloneDeep(practiceFiles);
        if (isAdd === true) {
            copyData.push({ fileName: "", file: null });
            setPracticeFiles(cloneDeep(copyData));
        } else {
            copyData.splice(index, 1);
            setPracticeFiles(cloneDeep(copyData));
        }
    };

    const checkFileExtension = (fileName: string) => {
        const allowedExtensions =
            /(\.pdf|\.doc|\.docx|\.txt|\.rtf|\.html|\.csv|\.ppt|\.pptx|\.jpeg|\.png|\.gif)$/i;
        if (!allowedExtensions.exec(fileName)) {
            return false;
        }
        return true;
    };

    const isRightFileExtension = (file: any) => {
        const fileName = file?.name;
        if (!fileName) return false;

        const isRight = checkFileExtension(fileName);
        return isRight;
    };
    const handleAddHomeworkFile = () => {
        const file = homeworkFileInput.current?.files?.[0];
        if (!isRightFileExtension(file)) {
            alert("Please upload a file with the right extension");
            return;
        }
        setHomeworkFileTitle(file?.name);
        putLearningMaterial(practiceFiles);
    };

    const handleAddSyllabusFile = () => {
        const file = syllabusFileInput.current?.files?.[0];
        if (!isRightFileExtension(file)) {
            alert("Please upload a file with the right extension");
            return;
        }
        setSyllabusTitle(file?.name);
        putLearningMaterial(practiceFiles);
    };
    console.log("syllabusTitle", syllabusTitle);

    const checkIsEmpty = (data) => {
        if(isEmpty(data)) return ""
        return data
    }

    const downloadFile = async () => {
        try {
            const response = await axios.get(stepData?.syllabus?.url, {
                responseType: "blob",
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", syllabusTitle);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Error downloading file:", error);
        }
    };

    const onClickDropdown = (item) => {
        setHomeworkCompletionTime(item);
    };

    useEffect(() => {
        if (stepData !== null) {
            if (stepData?.practiceFile && stepData?.practiceFile?.length !== 0) {
                setPracticeFiles(cloneDeep(stepData?.practiceFile));
            }
            if (stepData?.syllabus?.fileName) {
                setSyllabusTitle(stepData?.syllabus?.fileName);
            }
            if (stepData?.homework) {
                setQuestion(stepData?.homework?.homeworkTitle);
                setHomeworkFileTitle(stepData?.homework?.homework?.fileName);
                // setAnswer(stepData?.homework?.homeworkDetails);
            }
            if (stepData?.homework?.expectedCompletionTime) {
                setHomeworkCompletionTime(stepData?.homework?.expectedCompletionTime);
            }
        }
    }, [stepData]);

    useEffect(() => {
        if(!isEmpty(coachingData)){
            setAnswer(checkIsEmpty(coachingData?.coaching?.answer));
            setQuestion(checkIsEmpty(coachingData?.coaching?.question));
            setSyllabusTitle(checkIsEmpty(coachingData?.coaching?.showcase?.fileName));
        }
    }, [coachingData])

    useEffect(() => {
        setSubmit(!isEmpty(syllabusTitle));
    }, [syllabusFileInput?.current?.value, syllabusTitle]);

    const titleInputRef = useRef(null);

    useEffect(() => {
        titleInputRef?.current?.focus()
    }, [titleInputRef?.current]);
    console.log('coachingData', coachingData)

    return (
        <Container onSubmit={async (e)=>{
            e.preventDefault();
            await putShowcaseData()
            .then(res => {
                navigate("/create_coaching/testimonials", {
                    state:{
                        createId:createId
                    }
                })
            })
        }}>
            <Contents>
                <Header>
                    <h2>
                        Sample Q&A<strong>*</strong>
                    </h2>
                    <QueText style={{left:180, marginBottom:10}} />
                </Header>
                <p>
                    Add a sample question or video coaching message to help your students understand
                    your coaching style. You need to upload at least one sample.
                </p>
                {
                    uploadLoading &&
                    <Overlay filter={false}>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <rect x="15" y="30" width="10" height="40" fill="#ddc160">
                                <animate attributeName="opacity" dur="1s" repeatCount="indefinite" calcMode="spline"
                                         keyTimes="0;0.5;1" keySplines="0.5 0 0.5 1;0.5 0 0.5 1" values="1;0.2;1"
                                         begin="-0.6"/>
                            </rect>
                            <rect x="35" y="30" width="10" height="40" fill="#ddc160">
                                <animate attributeName="opacity" dur="1s" repeatCount="indefinite" calcMode="spline"
                                         keyTimes="0;0.5;1" keySplines="0.5 0 0.5 1;0.5 0 0.5 1" values="1;0.2;1"
                                         begin="-0.4"/>
                            </rect>
                            <rect x="55" y="30" width="10" height="40" fill="#ddc160">
                                <animate attributeName="opacity" dur="1s" repeatCount="indefinite" calcMode="spline"
                                         keyTimes="0;0.5;1" keySplines="0.5 0 0.5 1;0.5 0 0.5 1" values="1;0.2;1"
                                         begin="-0.2"/>
                            </rect>
                            <rect x="75" y="30" width="10" height="40" fill="#ddc160">
                                <animate attributeName="opacity" dur="1s" repeatCount="indefinite" calcMode="spline"
                                         keyTimes="0;0.5;1" keySplines="0.5 0 0.5 1;0.5 0 0.5 1" values="1;0.2;1"
                                         begin="-1"/>
                            </rect>
                        </svg>
                    </Overlay>
                }
                <TestItems>
                    <Row display={"flex"}>
                        <Col style={{width: "100%", flex: 1}}>
                            <FormBox>
                                <dt>Question</dt>
                                <dd>
                                    <FormBoxItemWrap>
                                        <li>
                                            <FormItem>
                                                <input
                                                    ref={titleInputRef}
                                                    type="text"
                                                    value={question}
                                                    maxLength={50}
                                                    onChange={(e) => {
                                                        setQuestion(e.target.value);
                                                    }}
                                                    placeholder="Please provide an example of a question  that your students could ask."
                                                />
                                                <TextLength>{isNaN(50 - Number(question?.length)) ? 50 :
                                                    50 - Number(question?.length)}</TextLength>
                                            </FormItem>
                                        </li>
                                    </FormBoxItemWrap>
                                </dd>
                            </FormBox>
                        </Col>
                    </Row>

                    <Row style={{marginBottom: 0}}>
                        <FormBox>
                            <dt>Answer</dt>
                            <dd>
                                <FormBoxItemWrap>
                                    <li>
                                        <FormItem style={{width: "calc(100%)"}}>
                                            <textarea
                                                style={{height: 160}}
                                                placeholder="Write your answer"
                                                onChange={(e) => {
                                                    setAnswer(e.target.value);
                                                }}
                                                value={answer}
                                                maxLength={1000}
                                            />
                                            <TextLength>
                                                {1000 - answer?.length || 1000}
                                            </TextLength>
                                        </FormItem>
                                    </li>
                                </FormBoxItemWrap>
                            </dd>
                        </FormBox>
                    </Row>
                </TestItems>

                <SampleTitle>
                    <h2 className={"video"}>Sample Video
                        {/*<strong>*</strong>*/}
                    </h2>
                    <p>
                        Add a video that effectively showcase your insights and knowledge to your
                        students. We recommend keeping the video length to no more that three
                        minutes.
                    </p>
                </SampleTitle>
                <VideoItems style={{ alignItems: "center"}}>
                    <FormItem
                        className={"form"}
                        style={{width: "100%", marginRight: 15}}>
                        {!isEmpty(syllabusTitle) ? (
                            <EditArea style={{transform: "translateY(-23px)"}}>
                                <span>{syllabusTitle}</span>
                                <div className="delete"
                                     onClick={async () => {
                                         syllabusFileInput.current.value = "";
                                         setSampleVideoFile(null)
                                         setSyllabusTitle("");
                                     }}>
                                    <Icon width={16} height={16} icon={DeleteIcon}/>
                                </div>
                            </EditArea>
                        ) : (
                            <input
                                // value={item.title}
                                value={""}
                                readOnly={true}
                                type="text"
                                placeholder="Upload a sample video"
                            />
                        )}
                    </FormItem>

                    <Browse className={"browse"}>
                        <PlusIcon/>
                        <span>Browse</span>
                        <input
                            required={isEmpty(syllabusTitle) && isEmpty(syllabusFileInput?.current?.files[0])}
                            type="file" ref={syllabusFileInput} onChange={async (e) => {
                            const file = e.target.files[0];
                            setSampleVideoFile(file);
                            // setSyllabusTitle(file?.name);
                            await handleUploadJWP(e)
                        }}/>
                    </Browse>
                </VideoItems>

                <Divider/>
            </Contents>
            <ButtonItems justifyContent={"flex-end"}>
                <Browse
                    className={"prev"}
                    style={{marginRight: 15, width: 100, height: 40}}>
                    <span style={{marginLeft: 0}}>Previous</span>
                </Browse>
                <button
                    type='submit'
                    className={"on continue"}
                >
                    Continue
                </button>
            </ButtonItems>
        </Container>
    );
};
export default Showcase;

const Container = styled.form`
    overflow-y: scroll;
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
    display: flex;
    flex-direction: column;
    animation: ${fadeIn} 0.4s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
    }
`;

const Contents = styled.div`
    padding: 20px 20px 10px 20px;
    //overflow: hidden;
    
    h2 {
        color: #333;
        font-family: "Europa-Regular";
        font-size: 26px;
        font-weight: 700;
        line-height: 26px;
        letter-spacing: 0em;
        text-align: left;
        margin-bottom: 15px;
        display: inline-block;
        strong {
            font-family: "Europa-Regular";
            font-weight: 700;
            line-height: 26px;
            letter-spacing: 0em;
            text-align: left;
            color: #da1414;
            vertical-align: text-top;
            font-size: 26px;
            text-align: left;
        }
    }
    p {
        color: #333!important;
        font-weight: 400;
        font-size: 18px;
        line-height: 23.6px;
        margin-bottom: 19.6px;
    }
`;
const Header = styled.div`
   display: flex;
    align-items: center;
    p{
        color: #fff!important;
    }
`
const TestItems = styled.div`
    border: solid 0.6px #33333399;
    border-radius: 15px;
    padding: 20px 15px;
    box-shadow: 0px 0px 6px 0px #33333329;
`;

const Row = styled.div<StyledComponentProps>`
    display: ${(props) => props.display};
    justify-content: space-between;
    margin-bottom: 15px;
`;
const Col = styled.div<StyledComponentProps>`
    width: calc((100% - 18px) / 2);
`;
const Divider = styled.div`
    width: calc(140%);
    transform: translateX(-20%);
    height: 0.6px;
    background: #333;
    opacity: 0.3;
`;
const FormBox = styled.dl`
    > dt {
        font-size: 18px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        color: #333333;
        margin-bottom: 10px;
        > strong {
            font-size: 13px;
            font-weight: 600;
            color: #da1414;
            display: inline-block;
            margin-left: 1px;
            vertical-align: top;
        }
    }
`;
const FormBoxItemWrap = styled.ul`
    > li {
        font-size: 16px;
        margin: 8px 0 0 0;
    }
`;
const FormItem = styled.div`
    position: relative;
    transition: all 0.2s;
    h2 {
        font-size: 14px;
        margin-bottom: 15px;
    }
    .guide {
        pointer-events: none;
    }

    > input[type="text"],
    select,
    textarea {
        transition: all 0.2s;
        width: 100%;
        font-family: Europa-Regular;
        font-size: 16px;
        outline: none;
        border-radius: 8px;
        border: solid 1px rgba(51, 51, 51, 0.3);
        padding: 12px 16px;
        &::placeholder {
            color: #ddd;
        }
    }
    > input[type="text"] {
        height: 48px;
        transition: all 0.2s;
    }
    > select {
        height: 48px;
        -webkit-appearance: none;
        appearance: none;
    }
`;

const EditArea = styled.div`
    position: absolute;

    width: 100%;
    height: 100%;
    border: solid 1px #33333360;
    z-index: 2;
    border-radius: 8px;
    padding: 0 15px;
    height: 48px;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    @media screen and (max-width: 768px) {
        position: relative;
        transform: none!important;
    }
    .delete {
        cursor: pointer;
        padding: 0 8px 2px 8px;
    }
    span {
        color: #333;
    }
`;

const TextLength = styled.span`
    color: rgba(51, 51, 51, 0.6);
    font-weight: 700;
    position: absolute;
    right: 16px;
    top: 17px;
`;
const SampleTitle = styled.div`
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    h2 {
        font-family: Europa-Bold;
        font-weight: 700;
        letter-spacing: 0em;
        text-align: left;
        color: #333;
        font-size: 20px;
        font-style: normal;
        line-height: 24px;
        strong {
            font-family: Europa-Bold;
            font-size: 16px;
            font-weight: 700;
            line-height: 26px;
            letter-spacing: 0em;
            text-align: left;
            color: #da1414;
            vertical-align: text-top;
        }
    }
    p {
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        color: #333;
    }
`;
const SelectArrow = styled.div`
    position: absolute;
    right: 16px;
    top: 15px;
`;

const ThumbnailWrap = styled.div`
    color: #333;
    font-size: 16px;
`;

const ThumbnailTitle = styled.h5`
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 15px;
    > strong {
        font-size: 13px;
        font-weight: 600;
        color: #da1414;
        display: inline-block;
        margin-left: 1px;
        vertical-align: top;
    }
`;

const ThumbnailText = styled.p`
    margin-bottom: 15px;
    line-height: 22px;
`;

const ThumbnailUpload = styled.div`
    width: 100%;
    height: 180px;
    padding: 9px 8px;
    border: 1px dashed rgba(51, 51, 51, 0.6);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    button {
        padding: 0;
        border: 0;
        background: none;
        line-height: 0;
        cursor: pointer;
    }
`;

const ThumbnailView = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    &::after {
        width: 100%;
        height: 100%;
        position: absolute;
        background: #000;
        opacity: 0.5;
        content: "";
    }
`;

const ThumbnailButtonList = styled.ul`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    > li {
        margin: 0 4px;
    }
`;

const ThumbnailUploadButton = styled.button`
    width: 100%;
    height: 100%;
    > span {
        display: block;
        font-size: 18px;
        font-family: Europa-Regular;
        margin-top: 10px;
        line-height: 100%;
    }
`;

const ButtonItems = styled.div<StyledComponentProps>`
    padding: 25px 20px;
    display: flex;
    justify-content: space-between;
    button {
        transition: all 0.2s;
        width: 100px;
        height: 40px;
        border: 0;
        cursor: pointer;
        padding: 11px 15px 11px 14px;
        color: #333;
        border-radius: 6px;
        background: #e5e5e5;
        &.on {
            background: #ddc160;
            color: #fff;
        }
    }
`;

const FormItems = styled.div`
    border: solid 1px #33333360;
    border-radius: 15px;
    overflow: hidden;
`;
const FormInner = styled.div`
    padding: 15px 15px 10px 15px;
    position: relative;
`;
const FormItemDivider = styled.div`
    width: 100%;
    height: 1px;
    background: #33333360;
`;
const VideoItemsWrap = styled.div`
    padding: 30px 15px 20px 15px;
    h2 {
        color: "#000";
        margin-bottom: 3px;
        font-size: 16px;
        font-weight: 400;
    }
`;
const VideoItems = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 30px;
    @media screen and (max-width: 768px) {
       flex-direction: column;
        .form{
            margin-right: 0!important;
        }
        .browse{
            width: 100% !important;
            min-width: 100%;
            max-width: 100%;
            height: 48px;
            min-height: 48px;
            margin-top: 8px;
        }
    }
`;
const CheckBox = styled.div`
    display: flex;
    margin-right: 13px;
    align-items: center;
    span {
        padding-top: 2px;
        font-size: 16px;
        color: #212529;
    }
    div {
        margin-right: 8px;
        width: 16px;
        height: 16px;
        border-radius: 4px;
        border: solid 1px #333;
    }
`;
const Browse = styled.div`
    height: 48px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px #333;
    flex: 1;
    width: 100%;
    min-width: 120px;
    max-width: 120px;
    position: relative;
    cursor: pointer;
    transition: all 0.2s;
    svg{
        path{
            fill: #333
        }
    }
    &:hover{
        background: #333;
        span{
            color: #fff;
        }
        svg{
            path{
                fill: #fff!important;
            }
        }
    }
    &.prev{
        width: 100px;
        min-width: 100px;
        max-width: 100px;
        padding: 0!important;
    }
    span {
        margin-left: 10px;
    }
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    input {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #333;
        opacity: 0;
        z-index: 3;
    }
    a {
        border: solid 1px #111;
        position: absolute;
        width: 100%;
        height: 100%;
        background: #ddd;
        display: flex;
        opacity: 0;
    }
`;
const CloseButton = styled.div`
    background: #333;
    position: absolute;
    right: 0;
    top: 0;
    width: 51px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;
const RemoveButton = styled.div``;

const AddButton = styled.div`
    height: 48px;
    border-radius: 8px;
    padding: 0 18.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px #333;

    width: 129px;
`;

const AddChapter = styled.div`
    background: #333;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    width: 106px;
    height: 40px;
    justify-content: center;
    border-radius: 5px;
    margin-top: 15px;
    cursor: pointer;
    span {
        color: #fff;
        font-size: 18px;
        margin-right: 10px;
        font-weight: 400;
    }
`;

const Transcript = styled.div`
    h3 {
        margin-top: 20px;
        margin-bottom: 14px;
        font-size: 26px;
        font-weight: 700;
    }
`;
